// import * as Integrations from '@sentry/integrations';
import Vue from 'vue';
import { inBrowser } from './app/web/utils';

const SENTRY_URL = process.env.NODE_ENV === 'production' ? 'sentry.kuaishou.com' : 'sentry.test.gifshow.com';

// 雷达配置
const weblogConfig = {
    config: {
        autoPV: false,
        env: process.env.NODE_ENV,
        crash: false,
        fps: true,
        timing: true,
        radar: {
            projectId: '4fa1f3d229', // 雷达平台上的唯一标识
            sampling: 1, // 上报采样率，1 为全部上报
        },
        logger: false,
    },
    product: {
        product_name: 'KUAISHOU',
    },
};

// // sentry 配置
// const sentryConfig = {
//     dsn: `${inBrowser ? location.protocol : ''}//6d3afaa19fdd430ba19ea0052efb4d48@${SENTRY_URL}/608`,
//     beforeBreadcrumb(breadcrumb) {
//         // 过滤掉打点的日志
//         if (breadcrumb.category === 'xhr' && breadcrumb.data.url === '/rest/wd/common/log/collect/misc2') {
//             return null;
//         }
//         return breadcrumb;
//     },
//     // 上报比例
//     sampleRate: 0.5,
//     environment: process.env.NODE_ENV === 'production' ? 'production' : 'test',
//     integrations: [
//         new Integrations.Vue({
//             Vue,
//             logErrors: true,
//         }),
//     ],
// };

// // sentry-webpack-plugin 插件的配置
// const sentryWebpackPluginConfig = {
//     organization: 'sentry',
//     project: 'league',
//     apiKey: 'c1331fc612c84858ab1180762da6aab37fba204d450046a0b6ca3283609f02d8',
//     suppressConflictError: true,
//     baseSentryURL: `https://sentry.test.gifshow.com/api/0`,
//     deleteAfterCompile: true,
//     filenameTransform(filename) {
//         const path =
//             process.env.UPLOAD_CDN === 'true' ? 'https://s2-10833.kwimgs.com/kos/nlav10833/league/' : '~/public/';
//         return `${path}${filename}`;
//     },
// };

// ktrace 配置
const ktraceConfig = {
    serviceName: 'kuai-locallife-h5',
    debug: false,
    // 过滤打点的请求 和 sentry 的请求
    ignoreUrlList: ['/rest/wd/common/log/collect/misc2', /sentry_key/],
    // resouceTiming: true,
    // 页面相关信息
    // fmp: false,
};

export default {
    weblogConfig,
    // sentryConfig,
    ktraceConfig,
    // sentryWebpackPluginConfig,
};
